import type { Signal } from "@suse-o11y/signal";
import { createContext, useContext } from "react";

const DropdownWithHostContext = createContext<null | Signal<boolean>>(null);

export const DropdownWithHostContextProvider = DropdownWithHostContext.Provider;

export const useIsDropdownWithHostOpen = (): null | Signal<boolean> => useContext(DropdownWithHostContext);
